function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ry2xzc4fga"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 117119",
    style: {
      fill: "#202020"
    },
    d: "M0 0h40.861v43.857H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137216"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137207",
    style: {
      clipPath: "url(#ry2xzc4fga)"
    },
    transform: "translate(7.569 6.071)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121149",
    d: "M38.379 56.96a2.319 2.319 0 0 0 2.287-2.011 19.267 19.267 0 0 0 .195-2.723 20.43 20.43 0 0 0-40.861 0 19.445 19.445 0 0 0 .2 2.723 2.32 2.32 0 0 0 2.29 2.011z",
    transform: "translate(0 -13.104)",
    style: {
      fill: "#202020"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121150",
    d: "M37.55 9.343A9.343 9.343 0 1 1 28.206 0a9.344 9.344 0 0 1 9.344 9.343",
    transform: "translate(-7.774)",
    style: {
      fill: "#202020"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonal);
export default __webpack_public_path__ + "static/media/icon_personal.682ee221de489b5bd36f08cc6a65a743.svg";
export { ForwardRef as ReactComponent };